import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'
import SeoSectionTitle from '../atoms/SeoSectionTitle'
import { connect } from 'react-redux'

const SeoSection = props => {
  const { lang, translations } = props
  const classes = useStyles()
  return (
    <>
      {lang === 'pl' &&
        <div>
          <SeoSectionTitle title={translations.title} subtitle={translations.sub_title} color='#94d224' />
            <div className={classes.infoBox}>
              <h2> {translations.section_1.title} </h2>
              <p> {translations.section_1.content} </p>
              <h2> {translations.section_2.title} </h2>
              <p>
                {translations.section_2.part_1}
                <a className={classes.link} href="https://www.facebook.com/kortydobczyce/" > {translations.section_2.link} </a>
                {translations.section_2.part_2}
              </p>
            </div>
        </div>
      }
    </>
  )
}

SeoSection.propTypes = {
  lang: PropTypes.string.isRequired,
  translations: PropTypes.object.isRequired,
}

const useStyles = createUseStyles({
  infoBox: {
    backgroundColor: 'white',
    marginTop: '2em',
    width: '98%',
    padding: '1em',
    marginBottom: '3em',
    border: '2px dashed #94d224',
    fontSize: '18px',
    lineHeight: '25px',
    textAlign: 'justify',
    '& h2': {
      color: '#94d224',
      fontSize: '19px',
      '&::after': {
        content: "''",
        display: 'block',
        width: '40px',
        height: '3px',
        marginTop: '0.5em',
        backgroundColor: '#94d224',
      },
    },
    '& li': {
      fontWeight: 'bold',
      fontStyle: 'italic',
    },
  },
  link: {
    textDecoration: 'none',
    color: '#868585',
    fontWeight: '700',
  },
  '@media(max-width: 960px)': {
    infoBox: {
      fontSize: '16px',
    },
  },
})

const mapStateToProps = (state) => {
  return {
    lang: state.translations.language,
    translations: state.translations.translations.area_page.seo_section,
  }
}

export default connect(mapStateToProps)(SeoSection)
